import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import { NHOM_KHACHHANG_LIST_SUCCESS } from './constants'
import * as nhomKhachHangAction from './actions'
import { storedb } from '../../views/client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import { confirmAlert } from 'react-confirm-alert';

class NhomKhachHang extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      item: {},
      list: [],
      keyword: '',
      per_page: 20,
      page: 1,
      total_record: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  fetchList = () => {
    const { nhomKhachHangListRequest } = this.props

    var requestData = {
      StoreId: this.state.stores_id,
      keyword: this.state.keyword,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return nhomKhachHangListRequest(requestData);
  }
  search = () => {
    if (this.props.nhomKhachHang.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  refresh = () => {
    this.setState({
      stores_id: this.state.stores_id,
      keyword: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.nhomKhachHang.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  EditNhomKhachHangItem = (item) => {
    this.props.history.push('/nhomkhachhang-edit?nhomkh=' + (item.NhomKhId || ""));
  }
  removeNhomKhachHangItem = (NhomKhId) => {
    var requestData = {
      NhomKhId: NhomKhId
    }
    return this.props.nhomKhachHangRemoveRequest(requestData, () => {
      this.fetchList()
    });
  }
  processRemoveClick = (item) => {
    if (item.NhomKhId <= 0) {
      return;
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn muốn xóa <span className="text-danger">{item.Ten}</span> không?
              </p>
            <button className="text-danger" onClick={() => {
              this.removeNhomKhachHangItem(item.NhomKhId)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  componentDidMount() {
    this.fetchList();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.nhomKhachHang.type == NHOM_KHACHHANG_LIST_SUCCESS) {
      let { list, item } = nextProps.nhomKhachHang;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    }
  }
  render() {
    const {
      handleSubmit,
      nhomKhachHang: {
        listRequesting,
        list,
        isRequesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." open={true}>
              <Row>
                <Col sm="12" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Tên nhóm khách hàng</InputGroupAddon>
                    <Input name="keyword" autoComplete="off" value={this.state.keyword} onChange={this.handleSearchChange.bind(this, "keyword")} />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1"
                onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <ButtonExt btnClass="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditNhomKhachHangItem({})}
                permission={BtnPermissions.NhomKhachHang.ADD_OR_UPDATE} />
            </div>
            <div className="w-100">
              <Row>
                <Col md="12">
                  {!isRequesting && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {!isRequesting && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </Col>
              </Row>
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Mã nhóm</th>
                    <th scope="col" className="text-left">Tên nhóm khách hàng</th>
                    <th scope="col" width="40" className="text-center">Sửa/Xóa</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left"><b>{res.NhomKhId}</b></td>
                        <td className="text-left">{res.Ten}</td>
                        <td scope="row" className="text-center">
                          <ButtonExt
                            btnClass="text-primary mr-1"
                            iconClass="fa-edit fa-lg"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.EditNhomKhachHangItem(res)}
                            permission={BtnPermissions.NhomKhachHang.ADD_OR_UPDATE} />
                          <ButtonExt
                            btnClass="text-danger mr-1"
                            iconClass="fa-trash fa-lg"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.processRemoveClick(res)}
                            permission={BtnPermissions.NhomKhachHang.REMOVE} />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  nhomKhachHang: state.nhomKhachHang,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  nhomKhachHangListRequest: nhomKhachHangAction.nhomKhachHangListRequest,
  nhomKhachHangUpdateRequest: nhomKhachHangAction.nhomKhachHangUpdateRequest,
  nhomKhachHangRemoveRequest: nhomKhachHangAction.nhomKhachHangRemoveRequest
})(NhomKhachHang)
const formed = reduxForm({
  form: 'nhomKhachHang',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/NhomKhachHang/NhomKhachHang.js